import React from 'react';

import { formatDate } from 'helpers/formatters/date_time_formats';
import { options as activityTypeOptions } from './activity_type';
import { options as parentTypeOptions } from './parent_type';
import Tag from 'components/tags/tag';

import type { FilterOptions } from 'bundles/apex/activities/types';
import type { Filters } from './types';


export interface Props {
  filterOptions?: FilterOptions;
  filters: Filters;
  onChange: (changes: Partial<Filters>, debounce?: boolean) => void;
}

export default function FilterTags({ filterOptions, filters, onChange }: Props) {
  const removeArrayOption = (filter: string, element: string) => {
    const newArray = filters[filter].filter(e => e !== element);
    onChange({ [filter]: newArray });
  };
  return (
    <div className="d-flex gap-1 flex-wrap">
      {filters.parentTypes.map(type => (
        <Tag
          key={`source-${type}`}
          label="Source"
          name="parentTypes"
          newDesignSystem
          removable
          onRemove={(_e, name) => removeArrayOption(name, type)}
        >
          {parentTypeOptions.find(option => option.value === type)?.label}
        </Tag>
      ))}
      {filters.activityTypes.map(type => (
        <Tag
          key={`type-${type}`}
          label="Type"
          name="activityTypes"
          newDesignSystem
          removable
          onRemove={(_e, name) => removeArrayOption(name, type)}
        >
          {activityTypeOptions.find(option => option.value === type)?.label}
        </Tag>
      ))}
      {filters.brokers.map(brokerId => (
        <Tag
          key={`broker-${brokerId}`}
          label="Broker"
          name="brokers"
          newDesignSystem
          removable
          onRemove={(_e, name) => removeArrayOption(name, brokerId)}
        >
          {filterOptions?.brokers.find(broker => broker.id.toString() === brokerId)?.name}
        </Tag>
      ))}
      {filters.dateRange.min && (
        <Tag
          key="date-min"
          label="Date"
          newDesignSystem
          removable
          onRemove={() => onChange({ dateRange: { ...filters.dateRange, min: null } })}
        >
          From {formatDate(filters.dateRange.min)}
        </Tag>
      )}
      {filters.dateRange.max && (
        <Tag
          key="date-max"
          label="Date"
          newDesignSystem
          removable
          onRemove={() => onChange({ dateRange: { ...filters.dateRange, max: null } })}
        >
          To {formatDate(filters.dateRange.max)}
        </Tag>
      )}
    </div>
  );
}
